<template>
  <div class="iframe-container">
    <iframe ref="iframeRef" :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";

export default {
  name: 'ApplicationIfram',
  data() {
    return {
      iframeSrc: '',
      dashboardData: {
        appId: "customer_account",
        projectToken: "6OIQTaRomEmu3PQBYKSEfT5I1LG5gQjH"
      }
    }
  },
  created() {
    this.iframeSrc = this.$route.query.iframeUrl
    
  },
  mounted() {
    if (this.$route.path === '/application/antiCrosstalk' || this.$route.path === '/application/sign') {
      window.addEventListener("message", this.handleMessage, false);
    }
  },
  destroyed() {
    if (this.$route.path === '/application/antiCrosstalk' || this.$route.path === '/application/sign') {
      window.removeEventListener("message", this.handleMessage, false);
    }
  },
  methods: {
    handleMessage(event) {
      const {data} = event;
      if (data.params) {
        const { key, base64Params, dashboardId, callbackId } = data.params;
        switch (data.cmd) {
          case "noticeTransferKey":
            // 处理业务逻辑
            this.getEncryptionParamsData(key, base64Params, dashboardId, callbackId);
            break;
          default:
        }
      }
    },
    sendMessage(key, token, timestamp, dashboardId, callbackId) {
      const {iframeRef} = this.$refs
      if (iframeRef) {
        const iframeWin = iframeRef.contentWindow;
        iframeWin.postMessage(
          {
            cmd: "sendTransferNewKey",
            params: { key, token, timestamp, dashboardId, callbackId }
          },
          "*"
        );
      }
    },
    getEncryptionParamsData(key, base64Params, dashboardId, callbackId) {
      const { dashboardData } = this
      if (dashboardData) {
        const timestamp = Date.parse(new Date());
        const {appId} = dashboardData;
        const privateKey = dashboardData.projectToken;
        const token = CryptoJS.MD5(appId + timestamp + privateKey + base64Params).toString();
        if (callbackId) {
          this.sendMessage(key, token, timestamp, dashboardId, callbackId);
        } else {
          this.sendMessage(key, token, timestamp, dashboardId);
        }
      }
    }
  },
}
</script>

<style lang="less" scoped>
.iframe-container {
  padding: 0 24px;
  height: calc(100vh - 90px);
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
